import React, { Component } from 'react'
import UserBasic from '../../../presentationals/Admin/CustomerPages/UserBasic.component'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { APIS } from '../../../../utils/api-factory';
import Loader from '../../../presentationals/Loader/Loader.component'
import CreditScore from './ScoringSection.container'
import Popup from '../../../presentationals/Popup/Popup.component';
import { _formatDateInDash } from '../../../../utils/validation';
import { sendverificationRequestApi, checkGaurantorcoborrowerByUserId } from '../AdminActionCreator.component'
import Confirmation from '../../../presentationals/Popup/ConfirmationPopup.component'
import EditProfile from '../../../containers/Admin/CustomerPages/EditUserDetails.container'
import Documents from '../../../containers/Admin/CustomerPages/UserDocs.container'
import Basic from '../../../containers/Admin/CustomerPages/detailingpage.container'
import Cibil from '../../../containers/Admin/CustomerPages/UserCibil.container'
import Scoring from '../../../containers/Admin/CustomerPages/Scoring.container'
import Crif from '../../../containers/Admin/CustomerPages/Crif.container'
import ConfirmationPopup from '../../../presentationals/Popup/crifConfirmationPopUp.component'
import BadaBuisnessEditProfile from '../../../containers/Admin/CustomerPages/BadabuisnessEdit.container'
// import CreditScore from './UserCreditScoring.container';
import { ROLE } from '../../../../utils/Constant'
import EditProfileTea from '../../../containers/Admin/CustomerPages/EditProfileTea.container'
import BasicTea from '../../../containers/Admin/CustomerPages/BasicTea.container'
import EditLoanId from '../../../containers/Admin/CustomerPages/editloanId'
import CoBorrowerGuarantardetailingPageContainer from './CoBorrowerGuarantardetailingPage.container';
import Action from './NewActionHandle';

class BasicUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmationPopup: false,
            confirmationText: '',
            loaderState: false,
            creditScoringPopup: false,
            popupState: false,
            popupStatus: '',
            senderMailId: '',
            allDetail: this.props.allDetail,
            mailIdForVerification: '',
            pageViewState: '',
            linkState: false,
            cibilScoringTabState: false,
            creditScoreTabState: false,
            teaGardenId: '',
            teaGardenData: '',
            teaEdit: false,
            reasonData: '',
            screenType: "borrower",
            coborrowerGuanrantorData: {},
            PayloadBorrowerId: ""
        }
    }
    tabsHandler(type, statetoset) {
        // console.log(type)
        if (type == 'cibilScoring') {
            if (this.state.cibilScoringTabState === true) {
                this.setState({ cibilScoringTabState: false })
            } else {
                this.setState({ cibilScoringTabState: true })
            }

        }
        if (type == 'creditScore') {
            if (this.state.creditScoreTabState === true) {
                this.setState({ creditScoreTabState: false })
            } else {
                this.setState({ creditScoreTabState: true })

            }
        }

    }

    userLinkHandler() {
        this.setState({ linkState: true })
    }
    componentDidMount() {
        const { allDetail, admin, showEditPorfile, showCrifDataTab, userDetail } = this.props;
        // console.log(this.props)
        this.setState({ loaderState: true })
        fetch(APIS.GET_USERS_DETAILS_BY_USER_ID + userDetail.userId)
            .then(res => res.json())
            .then(json => {
                if (Object.entries(json).length !== 0 && json.UserToEmpId?.teaGardenId !== null && json.UserToEmpId?.teaGardenId !== undefined) {
                    this.setState({ teaGardenId: json.UserToEmpId?.teaGardenId, loaderState: false, teaGardenData: json, teaEdit: true, pageViewState: 'basicPageTea' })
                } else {
                    this.setState({ loaderState: false, teaEdit: false, pageViewState: 'basicPage' })

                }
            })
        fetch(APIS.GET_REASONS_API + userDetail?.loanId)
            // .then(res => res.json())
            // .then(json => {
            //     this.setState({ reasonData: json })
            // })
            .then(res => {
                if (!res.ok) {
                    return "";
                }
                return res.text();
            })
            .then(text => {
                return text ? JSON.parse(text) : {};
            })
            .then(json => {
                this.setState({ reasonData: json });
            })







        this.checkGaurantorcoborrowerByUserIdFn(userDetail?.userId)
    }


    checkGaurantorcoborrowerByUserIdFn(id) {
        this.setState({ loaderState: true })
        checkGaurantorcoborrowerByUserId(id, callback => {
            this.setState({ loaderState: false })
            if (callback?.status == 200) {
                this.setState({ coborrowerGuanrantorData: callback?.data })
                if (this.state.screenType == "coBorrower" && !callback?.data?.coBorrowerExist) {
                    this.setState({ screenType: "borrower" })
                }
                if (this.state.screenType == "gaurantor" && !callback?.data?.guarantorExist) {
                    this.setState({ screenType: "borrower" })
                }
            } else {
                this.setState({ coborrowerGuanrantorData: {} })
            }
        })
    }

    handleScreenType(type) {
    
        let obj = {}
        if (type == "coBorrower") {
            obj = this.state.coborrowerGuanrantorData?.coBorrowers?.filter((el) => el?.status == "ACTIVE")
        } else if (type == "gaurantor") {
            obj = this.state.coborrowerGuanrantorData?.guarantors?.filter((el) => el?.status == "ACTIVE")
        }
         this.setState({ PayloadBorrowerId: obj?.[0]?.userId })

         setTimeout(()=>{
            this.setState({ screenType: type })
         },100)
    }

    render() {
        const { allDetail, allStatus, admin, showEditPorfile, showCrifDataTab, userDetail } = this.props;
        return (
            <div>
                {/* <Action admin={admin} allStatus={allStatus} userdata={allDetail} userDetail={userDetail} /> */}

                {this.state.loaderState ?
                    <Loader />
                    : ""}



                {this.state.pageViewState == 'basicPage' ?
                    <div>

                        <div style={{ position: "absolute", right: '40px', top: '27px', zIndex: '1' }}>
                            <button className={`customDetailingButton ${this.state.screenType == "borrower" ? "active" : ""}`} onClick={() => this.handleScreenType("borrower")}>Borrower</button>
                            <button className={`customDetailingButton ${this.state.coborrowerGuanrantorData?.coBorrowerExist == false ? "disabled" : this.state.screenType == "coBorrower" ? "active" : ""}`} disabled={this.state.coborrowerGuanrantorData?.coBorrowerExist == false ? true : false} onClick={() => this.handleScreenType("coBorrower")}>Co-Borrower</button>
                            <button className={`customDetailingButton ${this.state.coborrowerGuanrantorData?.guarantorExist == false ? "disabled" : this.state.screenType == "gaurantor" ? "active" : ""}`} disabled={this.state.coborrowerGuanrantorData?.guarantorExist == false ? true : false} onClick={() => this.handleScreenType("gaurantor")}>Guarantor</button>
                        </div>

                        {
                            this.state.screenType == "borrower" ?
                                <Basic
                                    UserDetailTabsHandler={this.props.UserDetailTabsHandler}
                                    allStatus={allStatus}
                                    userDetailHandler={this.props.userDetailHandler}
                                    reasonData={this.state.reasonData}
                                    userLinkHandler={this.userLinkHandler.bind(this)}
                                    linkState={this.state.linkState}
                                    userDetail={userDetail}
                                    closePopup={this.closePopup.bind(this)}
                                    popupStatus={this.state.popupStatus}
                                    allDetail={allDetail}
                                    getCreditPopupState={this.getCreditPopupState.bind(this)}
                                    creditScoringPopup={this.state.creditScoringPopup}
                                    admin={admin}
                                    cancelLoanConfirm={this.cancelLoanConfirm.bind(this)}
                                    confirmationText={this.state.confirmationText}
                                    arr={this.state.arr}
                                />
                                : ""}

                        {this.state.screenType !== "borrower" ?
                            <CoBorrowerGuarantardetailingPageContainer
                                userDetails={userDetail} viewType={this.state.screenType}
                                admin={admin}
                                PayloadBorrowerId={this.state.PayloadBorrowerId}
                            />
                            : ""}
                    </div>
                    : this.state.pageViewState == 'editPage' && userDetail.loanFrom !== 'bazarBussiness' ?
                        <EditProfile
                            getData={this.props.getData.bind(this)}
                            allDetail={allDetail}
                            admin={admin}
                            userDetails={this.props.userDetail} />
                        :
                        this.state.pageViewState == 'editloanId' ?
                            <EditLoanId
                                getData={this.props.getData.bind(this)}
                                allDetail={allDetail}
                                admin={admin}
                                userDetails={this.props.userDetail} />
                            :
                            this.state.pageViewState == 'editPageTea' ?
                                <EditProfileTea
                                    getData={this.props.getData.bind(this)}
                                    allDetail={allDetail}
                                    admin={admin}
                                    userDetails={this.props.userDetail}
                                    teaGardenData={this.state.teaGardenData}
                                />
                                :
                                this.state.pageViewState == 'editPage' && userDetail.loanFrom === 'bazarBussiness' ?
                                    <BadaBuisnessEditProfile
                                        getData={this.props.getData.bind(this)}
                                        allDetail={allDetail}
                                        admin={admin}
                                        userDetails={this.props.userDetail} />
                                    : this.state.pageViewState == 'cibil' ?
                                        <Cibil
                                            allDetail={this.state.allDetail}
                                        />
                                        : this.state.pageViewState == 'popUp' ?
                                            <ConfirmationPopup
                                                ConfirmCrifDataGenerate={this.ConfirmCrifDataGenerate.bind(this)}
                                            />
                                            : this.state.pageViewState == 'crifData' ?
                                                <Crif
                                                    allDetail={this.state.allDetail}
                                                />
                                                : this.state.pageViewState == 'docsPage' ?
                                                    <Documents
                                                        markCompleteBtn={this.props.markCompleteBtn}
                                                        allDetail={allDetail}
                                                        admin={admin}
                                                        userDetail={userDetail}
                                                    />
                                                    // : this.state.pageViewState == 'scoring' ?
                                                    //     <Scoring
                                                    //     getData={this.props.getData.bind(this)}
                                                    //         allDetail={allDetail}
                                                    //         admin={admin} />

                                                    : this.state.pageViewState == 'basicPageTea' ?

                                                        <BasicTea
                                                            allDetail={allDetail}
                                                            teaGardenData={this.state.teaGardenData}
                                                            userDetail={userDetail}
                                                            admin={admin}
                                                            linkState={this.state.linkState}
                                                            userLinkHandler={this.userLinkHandler.bind(this)}
                                                        />
                                                        : null}
            </div>
        )
    }




    sendHandler(type) {
        this.setState({
            pageViewState: type,
        })
    }
    ConfirmCrifDataGenerate(dataType) {
        if (dataType == 'yes') {
            this.setState({
                pageViewState: 'crifData'
            })

        } if (dataType == 'no') {
            this.setState({
                pageViewState: 'basicPage'
            })
        }
    }


    cancelLoanConfirm(conType) {
        if (conType == 'yes') {
            sendverificationRequestApi(this.state.mailIdForVerification,
                (callBack) => {
                    if (callBack == 'success') {
                        this.setState({
                            popupState: true,
                            popupStatus: 'Mail has been successfully sent to user.',
                            confirmationPopup: false
                        })
                        this.removePopup()
                    } else {
                        this.setState({
                            popupState: true,
                            popupStatus: 'Please try again.',
                            confirmationPopup: false
                        })
                        this.removePopup()
                    }
                })
        } else if (conType == 'no') {
            this.setState({ confirmationPopup: false })
        }
    }

    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }

    closePopup() {
        this.setState({ popupState: false });
    }


    getCreditPopupState(state) {
        this.props.getCreditPopupState(state)
    }

    detailBackHandler() {
        this.props.basicBackHandler()
    }

    verifyMail(mailId) {
        this.setState({
            mailIdForVerification: mailId,
            confirmationText: 'Are you sure for send verification mail to this user?',
            confirmationPopup: true
        })

    }

    componentWillUnmount() {

    }

}
const mapStateToProps = ({ pendingDetail }) => {
    return {
        pendingDetail: pendingDetail
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(BasicUser);